import React from "react";
import NoMatch from "./NoMatch";

export interface RouteInfo {
    path: string,
    component: any,
    routes?: RouteInfo[],
    lazy?: boolean,
    protected?: boolean
}

const ReactLazyPreload = (importStatement: any) => {
    const Component: any = React.lazy(importStatement);
    Component.preload = importStatement;
    return Component;
};

//preload pages
const Dashboard = ReactLazyPreload(() => import('./pages/dashboard/Dashboard'));
Dashboard.preload();

const LevelTree = ReactLazyPreload(() => import('./pages/level-tree/LevelTree'));
LevelTree.preload();

const Login = ReactLazyPreload(() => import('./pages/login/Login'));
Login.preload();

const SignUp = ReactLazyPreload(() => import('./pages/sign-up/SignUp'));
SignUp.preload();

const Profile = ReactLazyPreload(() => import('./pages/profile/Profile'));
Profile.preload();

const MyTeam = ReactLazyPreload(() => import('./pages/my-team/MyTeam'));
MyTeam.preload();

const UserManagement = ReactLazyPreload(() => import('./pages/user-management/UserManagement'));
UserManagement.preload();

const CreateUser = ReactLazyPreload(() => import('./pages/user-management/create-user/CreateUser'));
CreateUser.preload();

const SignUpAdmin = ReactLazyPreload(() => import('./pages/signup-admin/SignUpAdmin'));
SignUpAdmin.preload();

const Configuration = ReactLazyPreload(() => import('./pages/configuration/Configuration'));
Configuration.preload();

const BankDetails = ReactLazyPreload(() => import('./pages/profile/bank-details/BankDetails'));
BankDetails.preload();

const ChangePassword = ReactLazyPreload(() => import('./pages/profile/change-password/ChangePassword'));
ChangePassword.preload();

const ChangeTransactionPassword = ReactLazyPreload(() => import('./pages/profile/change-transaction-password/ChangeTransactionPassword'));
ChangeTransactionPassword.preload();

const WithdrawalHistory = ReactLazyPreload(() => import('./pages/wallet/withdrawal-history/WithdrawalHistory'));
WithdrawalHistory.preload();

const WalletApproval = ReactLazyPreload(() => import('./pages/wallet/wallet-approval/WalletApproval'));
WalletApproval.preload();

const WalletTransfer = ReactLazyPreload(() => import('./pages/wallet/wallet-transfer/WalletTransfer'));
WalletTransfer.preload();

const RolePermissionManagement = ReactLazyPreload(() => import('./pages/role-permission/RolePermissionManagement'));
RolePermissionManagement.preload();

export const routes: RouteInfo[] = [
    {
        path: "/dashboard",
        component: Dashboard,
        protected: true
    },
    {
        path: "/network/level-tree",
        component: LevelTree,
        protected: true
    },
    {
        path: "/login",
        component: Login,
        protected: false
    }, 
    {
        path: "/signup",
        component: SignUp,
        protected: false
    },
    {
        path: "/network/team",
        component: MyTeam,
        protected: true
    },
    {
        path: "/user-management",
        component: UserManagement,
        protected: true
    },
    {
        path: "/user-management/create",
        component: CreateUser,
        protected: true
    },
    {
        path: "/signup-admin",
        component: SignUpAdmin,
        protected: true
    },
    {
        path: "/configuration",
        component: Configuration,
        protected: true
    },
    {
        path: "/profile",
        component: Profile,
        protected: true
    },
    {
        path: "/profile/bank-details",
        component: BankDetails,
        protected: true
    },
    {
        path: "/profile/change-password",
        component: ChangePassword,
        protected: true
    },
    {
        path: "/profile/change-transaction-password",
        component: ChangeTransactionPassword,
        protected: true
    },
    {
        path: "/wallet/transfer",
        component: WalletTransfer,
        protected: true
    },
    {
        path: "/wallet/approval",
        component: WalletApproval,
        protected: true
    },
    {
        path: "/wallet/withdrawal",
        component: WithdrawalHistory,
        protected: true
    },
    {
        path: "/role-permission",
        component: RolePermissionManagement,
        protected: true
    },
    {
        path: "*",
        component: NoMatch
    },
];